import React from "react";
import { IoMdAdd } from "react-icons/io";

const ThemeAddButton = ({ text, className, onClick }) => {
  return (
    <div
      className={`theme-add-btn d-flex align-items-center gap-2 cursor ${className}`}
      onClick={onClick}
    >
      <IoMdAdd color="#426dab" size={15} />
      <span>{text}</span>
    </div>
  );
};

export default ThemeAddButton;
